import {defineComponent, PropType} from 'vue';
import DateUtil from "@/app/shared/helpers/date-util";
import {IInvoiceListItem} from '@/api/klip-api.proxy';

export default defineComponent({
    name: 'KlInvoiceCard',
    methods: {
        DateUtil() {
            return DateUtil
        }
    },
    props: {
        invoiceCard: {
            type: Object as PropType<IInvoiceListItem>,
            required: true,
        },
    },
    setup(props) {

        return {
        };
    }
});
